import React from 'react'

function Footer() {
    return (
        <div className='text-center py-3 fs-5'>Developed By Basharat Ali Sahito &#169; 2026</div>
    )
}
export default Footer